import { RouteType } from "constants/RouteType";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { AuthModel } from "model/utilModels/AuthModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { AuthService } from "services/auth/AuthService";

export class MembershipService {
  constructor() { }

  static addMembership = async (requestData: MembershipModel) => {
    const url = RouteType.ADMIN + RouteType.UPDATE_MEMBER;
    const response = await AuthService.postCryptoRequest(url, JSON.stringify(requestData))
    return response;
  };

  static addBranch = async (requestData: MembershipModel) => {
    const url = RouteType.ADMIN + RouteType.MEMBER_BRANCH_REGISTER;
    const response = await AuthService.postCryptoRequest(url, JSON.stringify(requestData))
    return response;
  };

  

  static getregisteredMembersList = async (requestBody: PaginatorModel) => {
    const url = RouteType.ADMIN + RouteType.MEMBER;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  // To Get The Update Of Membership Status

  static updateMembershipStatus = async (requestBody: MembershipModel) => {
    const url = RouteType.ADMIN + RouteType.UPDATE_MEMBER_STATUS;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  }

  static updateUserIdAndPassword = async (requestBody: MembershipModel) => {
    const url = RouteType.ADMIN + RouteType.UPDATE_MEMBER_PASSWORD;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  }

  static deleteMembership = async (requestBody: MembershipModel) => {
    const url = RouteType.ADMIN + RouteType.MEMBER + RouteType.DELETE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };
}